export default __webpack_public_path__ + "static/media/qcto-logo.93d7b7a8.png";